import type { FaireProductEntity } from "../../entity_types/product";

export const p_xm8ckeeeuz: FaireProductEntity = {
  token: "p_xm8ckeeeuz",
  type: "product",
  name: "SOFT BLUE WOOL TRIANGLE SCARF",
  brandToken: "b_vba92wh7ve",
  brandName: "Beaten Path Co",
  imageUrl: "https://cdn.faire.com/fastly/a0659652826898c3a253c1481b9ed22aa7b9aae099306df09b348f923abce4db.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/63aca586f46eefa2ae31dd3bfc6f484b3e0be84cbebe5edba3204778d4bda7e0.jpeg",
    "https://cdn.faire.com/fastly/0a447acdd2e2c8279e1dd30b9abef3b34a810dbdcef49ad44a3a48050c09acfa.jpeg",
    "https://cdn.faire.com/fastly/2dfb3d31e68dcb4cb9bfa6732009e29f265d3d4894c16fef871b3c7222b92369.jpeg",
    "https://cdn.faire.com/fastly/df351e3321ac9bec84774f8932e649b3bc9a03e602ade3f3dd149ee5c27208d9.jpeg",
    "https://cdn.faire.com/fastly/89239d1a9364f9647fcd8baffc477ec233e572670e0bdaf6d987d806ff727a6b.jpeg",
    "https://cdn.faire.com/fastly/bdf3d2ba433434ed54c9e6aad71815be63f9972a65a434b5c811f19f7a4006b3.jpeg"
  ],
  priceDollars: 14,
  description: "A soft pop of color for early mornings by the water and slow, open-air days.\n\nThe Soft Blue Triangle Scarf brings a calm, easy feel to your outdoor wardrobe. With its light blue tone and classic triangle shape, it’s perfect for tying around your neck, tucking under your collar, or wearing as a headscarf when the breeze rolls in.\n\n * Lightweight and breathable \n * Earthy, sweet, and versatile \n * Easy to style—neck, hair, or tucked in a basket bag \n * Perfect for picnics, garden strolls, or rainy day rambles \n * One size fits all \nMaterials: 65% wool, 5% viscose, 10% acrylic, 10% nylon, 10% polyester\n",
  tags: [],
  msrpDollars: 28,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-06T17:55:42.972Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
